import {
  Card,
  Collapse,
  Title,
  Flex,
  Text,
  Divider,
  useMantineTheme,
} from "@mantine/core";
import { useState } from "react";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import { FaCheck, FaLock } from "react-icons/fa";
import { TLesson, TModule } from "../../types/Aula/TCourse";
import { TProgress } from "../../types/Aula";
import { useMediaQuery } from "@mantine/hooks";
import { useNavigate } from "react-router-dom";
import { notifications } from "@mantine/notifications";

export const ExpandableModule = ({
  module,
  progress,
  opened = false,
  isEnrollmentActive = true,
}: {
  module: TModule;
  progress: TProgress[];
  opened: boolean;
  isEnrollmentActive: boolean;
}) => {
  const theme = useMantineTheme();
  const [isOpened, setIsOpened] = useState(opened);
  const isMobile = useMediaQuery("(max-width: 992px)");
  const navigate = useNavigate();

  const handleLessonClick = (lesson: TLesson, isAccessible?: boolean) => {
    if (!isEnrollmentActive) {
      notifications.show({
        title: "Inscripción finalizada",
        message:
          "No puedes acceder a esta clase porque tu inscripción ha finalizado.",
        position: "bottom-right",
        color: "yellow",
        autoClose: 5000,
        icon: <FaLock />,
        withBorder: true,
      });
    } else {
      if (isAccessible) {
        navigate(`content/${lesson.id}`, {
          state: { category: lesson.category },
        });
      } else {
        notifications.show({
          title: "Clase bloqueada",
          message: "Completa las clases anteriores para acceder a esta clase.",
          position: "bottom-right",
          color: "yellow",
          autoClose: 5000,
          icon: <FaLock />,
          withBorder: true,
        });
      }
    }
  };

  return (
    <Card shadow="xs" padding="xl" w={isMobile ? "100%" : "60%"}>
      <Text fw={500} size="sm" c={theme.colors["genderlab-red"][5]} mb="xs">
        {module.order ? `Módulo ${module.order}` : "Introducción"}
      </Text>
      <Flex justify="space-between" align="center">
        <Title order={isMobile ? 5 : 3} maw={isMobile ? "60%" : "70%"}>
          {module.name}
        </Title>
        <Flex align="center" gap="xs">
          <Text fz={isMobile ? "sm" : "md"}>
            {module.lessons.length}{" "}
            {module.lessons.length === 1 ? "clase" : "clases"}
          </Text>
          <Flex
            align="center"
            justify="center"
            onClick={() => setIsOpened(!isOpened)}
            style={{
              cursor: "pointer",
              fontSize: "1.5rem",
            }}
          >
            {isOpened ? <FiChevronUp /> : <FiChevronDown />}
          </Flex>
        </Flex>
      </Flex>
      <Divider my="sm" />
      <Collapse in={isOpened}>
        {module.lessons.map((lesson, index) => {
          const lessonProgress = progress.find((p) => p.lesson === lesson.id);
          const isAccessible = lessonProgress?.is_accesible;
          const isCompleted = lessonProgress?.completed_at;

          return (
            <div key={lesson.id}>
              <Flex align="center" justify="space-between" gap="sm">
                <Flex
                  align="center"
                  gap="sm"
                  w="90%"
                  style={{
                    cursor: "pointer",
                    opacity: isAccessible && isEnrollmentActive ? 1 : 0.6,
                    position: "relative",
                  }}
                  onClick={() => handleLessonClick(lesson, isAccessible)}
                >
                  <Text fz={isMobile ? "sm" : "md"} component="a">
                    {module.order
                      ? `${module.order}.${index + 1} ${lesson.name}`
                      : lesson.name}
                  </Text>
                </Flex>
                {isCompleted ? (
                  <FaCheck color="green" />
                ) : isAccessible ? (
                  <Text
                    fz={isMobile ? "xs" : "sm"}
                    component="a"
                    style={{
                      cursor: "pointer",
                      color: theme.colors["genderlab-red"][6],
                    }}
                    onClick={() => handleLessonClick(lesson, isAccessible)}
                  >
                    Ver clase
                  </Text>
                ) : (
                  <FaLock color="gray" />
                )}
              </Flex>
              {index < module.lessons.length - 1 && <Divider my="xs" />}
            </div>
          );
        })}
      </Collapse>
    </Card>
  );
};
